"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xhrOptionsDefault = void 0;
const types_1 = require("./types");
exports.xhrOptionsDefault = {
    headers: {
        'Content-Type': types_1.MediaType.JSON,
        'Accept': 'application/json',
    },
    plugins: [],
    responseType: types_1.MediaType.JSON,
};
//# sourceMappingURL=options.js.map